<template>
  <div class="kanban-column" :style="getCotacoesCardStyle()">
    <cotacoes-card
      v-for="(item, index) in cotacoes"
      :key="index"
      :item="item"
      :color="grabColorByType(item.fase)"
      :remove-border-left="removeBorderLeft"
      :remove-border-right="removeBorderRight"
      :action-right-text="getActionRightText(item)"
      @card-clicked="(cotacao) => $emit('card-clicked', cotacao)"
    ></cotacoes-card>
  </div>
</template>
<script lang="js">
export default {
  name: "CotacoesColumn",
  props: ["cotacoes", "title", "removeBorderLeft", "removeBorderRight"],
  methods: {
    grabColorByType(type) {
      let color = "";
      switch (type) {
        case "ACAO_CORRETOR":
          color = "#DCCF0A";
          break;

        case "ANALISE":
          color = "#282498";
          break;

        case "EMITIDA":
          color = "#74DB03";
          break;

        case "RECUSADA":
          color = "#636363";
          break;
      }

      return color;
    },
    getCotacoesCardStyle() {
      let style = [];
      let t = this;
      style.push({ borderBottom: ".3vh solid" + t.color });
      if (t.removeBorderLeft) {
        style.push({ borderLeft: "none" });
      }
      if (t.removeBorderRight) {
        style.push({ borderRight: "none" });
      }
      return style;
    },
    getActionRightText(item) {
      return (
        this.$moment(item.inicio_vigencia).format("DD/MM/YYYY") +
        " à " +
        this.$moment(item.fim_vigencia).format("DD/MM/YYYY") +
        " - " +
        item.dias_vigencia +
        " dias"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.kanban-column-title {
  height: 43px;
  padding-left: 10px;
  padding-right: 10px;
  border-top: 1px solid #cbcbcb;
  border-bottom: 1px solid #cbcbcb;

  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  line-height: 43px;
  color: #35343d;
  font-weight: bold;
  .right {
    color: #979797;
    font-size: 16px;
  }
}
.kanban-column {
  border: 1px solid #cbcbcb;
  border-top: none;
  display: flex;
  flex-direction: column;
  height: calc(100%);
}
</style>



// WEBPACK FOOTER //
// ./src/components/CotacoesColumn.vue